import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { NUMBER_SIZE } from '../../../../constants/size'
import Button from '../../../Button'
import { ICON_COLOR, ICON_HEIGHT_12, IconNG } from '../../../Icon'
import { QA_NAME_GRETA_AI_LAUNCHER } from '../LayoutOverlay.constants'

import * as styles from './GretaAIActionButton.module.css'

import LockIcon from '../../../../icons/lock-filled.svg'
import GretaIcon from '../../../../icons/unique/ai/greta.png'

function GretaAIActionButton({
  hasUnread,
  isFinanceUnread = false,
  isLocked,
  tooltip = null,
  ...restProps
}) {
  const { t } = useTranslation()

  const launcherTooltip = tooltip ?? t('Common.GretaAIActionButtonToolipKey')

  return (
    <span className={styles.launcher}>
      <Button.Icon
        {...restProps}
        className={styles.GretaAiButton}
        height={NUMBER_SIZE.size48}
        qaName={QA_NAME_GRETA_AI_LAUNCHER}
        tooltip={launcherTooltip}
        tooltipClassName={styles.tooltip}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.left}
      >
        <img alt='GretaAI' className={styles.icon} src={GretaIcon} />
      </Button.Icon>
      {isLocked ? (
        <span className={classNames(styles.badge, styles.locked)}>
          <IconNG
            Icon={LockIcon}
            color={ICON_COLOR.SecondaryTextColor}
            size={ICON_HEIGHT_12}
          />
        </span>
      ) : hasUnread ? (
        <span
          className={classNames(styles.badge, styles.unread, {
            [styles.unreadFinance]: isFinanceUnread,
          })}
        />
      ) : null}
    </span>
  )
}

export default GretaAIActionButton
